import React from 'react';
import createReactClass from 'create-react-class';
import {SortableItemMixin, SortableContainer} from 'react-anything-sortable';

import closerPNG from '../../static/img/new/closer.png';

export default createReactClass({
    mixins: [SortableItemMixin],

    getDefaultProps() {
        return {
            image: {},
            className: 'sortable-photo',
            deleteImage: (objectId, imageId) => {
            }
        }
    },

    render() {
        const {name} = this.props.image;
        const imageName = name != null && name !== '' ? name : 'no-name.jpeg';

        return this.renderWithSortable(
            <SortableContainer {...this.props}>
                <div className={this.props.className}>
                    <div className="image_thumb">
                        <div
                            draggable={false}
                            className="thumb__image"
                            style={{
                                backgroundImage: `url(${this.props.src})`
                            }}
                        />

                        <div
                            title={this.props.image.name}
                            className="clearfix closer"
                        >
                            <img src={closerPNG} alt="" onClick={() => {
                                this.props.deleteImage(this.props.image.objectId, this.props.image.id, imageName)
                            }} />
                            {imageName}
                        </div>
                    </div>
                </div>
            </SortableContainer>
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/SortablePhoto.js